/**
 * Toast notification component
 * @param {string} msg - Message to display
 * @param {string} type - 'success' or 'error'
 */
export function Toast({ msg, type = 'success' }) {
  const bg = type === "error" ? "#7f1d1d" : "#052e16";
  const border = type === "error" ? "#f87171" : "#34d399";

  return (
    <div style={{
      position: "fixed",
      bottom: 24,
      left: "50%",
      transform: "translateX(-50%)",
      background: bg,
      color: "#fff",
      padding: "12px 24px",
      borderRadius: 12,
      fontWeight: 700,
      fontSize: 14,
      zIndex: 9999,
      border: `1px solid ${border}`,
      animation: "sIn 0.3s ease",
      fontFamily: "'Cairo',sans-serif",
      whiteSpace: "nowrap"
    }}>
      {msg}
    </div>
  );
}
